<div>
  <div class="content-social">
    <a href="https://www.instagram.com/diutinglobal/" target="_blank">
      <img [src]="social.image" class="w-100 social" alt="">
    </a>
  </div>
  <!-- <div class="d-flex al-center sp-center mt-4 content-icons-social">
    <img src="assets/svg/instagram-icon.svg" alt="">
    <div class="line"></div>
    <img src="assets/svg/favorite-icon.svg" alt="">
    <span>{{social.count}}</span>
  </div> -->
</div>
<br><br><br>